import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { XCircle } from 'lucide-react';

export default function PaymentCancelPage() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-secondary/20">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center">
          <div className="w-20 h-20 rounded-full bg-red-100 mx-auto mb-4 flex items-center justify-center">
            <XCircle className="w-10 h-10 text-red-600" />
          </div>
          <h1 className="text-2xl font-bold mb-2">Pagamento Annullato</h1>
          <p className="text-muted-foreground mb-6">
            Il pagamento è stato annullato. Il tuo carrello è stato conservato.
          </p>
          <div className="space-y-3">
            <Button className="w-full" asChild>
              <Link to="/">Torna alla Home</Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
